import { useRecoilValue } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import {
  HandexInstance,
  HanjinInstance,
  LogenInstance,
  LotteInstance,
} from "../instance";
import { trackingValueState } from "../../stores/barcode/trackingValueState";

// TODO 운송장 이미지 조회 API
const useGetImgUrl = () => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const trackingValue = useRecoilValue(trackingValueState); // 화물추적 날짜 / 운송장 번호

  // NOTE 회사별 API
  const apiInstances = {
    LOGEN: LogenInstance,
    LOTTE: LotteInstance,
    HANJIN: HanjinInstance,
    HANDEX: HandexInstance,
  };

  // NOTE 회사별로 올바른 API 인스턴스를 선택
  const apiInstance = apiInstances[login.company];

  // 고객사가 존재하지 않는다면
  if (!apiInstance) {
    throw new Error("Invalid company");
  }

  // TODO API 통신결과
  const mutationOptions = {
    // 성공 시
    onSuccess: (data) => {
      if (data.result === "00" || data.result === "77") {
        const imgUrl = "data:image/jpeg;base64," + data.data[0].img;
        const newWindow = window.open("", "_blank", "width=620,height=700,scrollbars=no,location=no");

        // 새로운 blank 페이지 열기
        if (newWindow) {
          newWindow.document.write(`
            <html>
            <head>
                <title>이미지 보기</title>
                <style>
                body {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin: 0;
                    padding: 0;
                    height: 100%;
                }
                img {
                    width: 100%;
                    height: 100%;
                    transition: transform 0.5s ease, filter 0.3s ease;
                }
                .imgContainer {
                    width: 96%;
                    height: 80%;
                    overflow: auto;
                }
                .button-container {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    padding: 10px;
                    box-sizing: border-box;
                }
                button, input {
                    padding: 10px 20px;
                    cursor: pointer;
                }
                </style>
            </head>
            <body>
                <div class="imgContainer">
                  <img id="image" src="${imgUrl}" alt="Image" style="filter: brightness(100%);"/>
                </div>
                <div class="button-container">
                    <button onclick="rotateImage(2)">반시계방향 회전 (-90°)</button>
                    <button onclick="rotateImage(1)">시계방향 회전 (+90°)</button>
                </div>
                <div class="button-container">
                    <label for="brightness">밝기 조절: </label>
                    <input type="range" id="brightness" name="brightness" min="0" max="1000" value="100" oninput="adjustBrightness(this.value)">
                </div>
                <script>
                let rotation = 0;
                function rotateImage(direction) {
                    const image = document.getElementById("image");
                    rotation += direction === 1 ? 90 : -90;
                    image.style.transform = "rotate(" + rotation + "deg)";
                }
          
                function adjustBrightness(value) {
                    const image = document.getElementById("image");
                    image.style.filter = "brightness(" + value + "%)";
                }
                </script>
            </body>
            </html>
          `);          
        }
      }
    },
    // 실패 시
    onError: (error) => {
      console.error(error);
    },
  };

  // TODO API 리퀘스트 정보
  const postData = {
    api: "imgGet",
    data: [{
        barcode: trackingValue.barcode,
        scandate: trackingValue.scanDate,
    }]
  };

  const mutationFn = () => apiInstance.post("/loin", postData);

  return useMutation("getAmount", mutationFn, mutationOptions);
};

export default useGetImgUrl;
